import SvgIcon from "./SvgIcon";

export default function PickleballIcon({
  width = "24",
  height = "24",
  color = "#000"
}) {
  return (
    <SvgIcon width={width} height={height}>
      <path
        d="M4.5 0a3.5 3.5 0 100 7 3.5 3.5 0 000-7zM3 3.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM17.829 2.414l4.757 4.758a4 4 0 010 5.656l-4 4A4 4 0 0115.758 18h-4.343l-4.5 4.5a2 2 0 01-2.829 0L2.5 20.914a2 2 0 010-2.828l4.5-4.5V9.243a4 4 0 011.172-2.829l4-4a4 4 0 015.657 0zM3.914 19.5L5.5 21.086 9.585 17 8 15.415zM15.758 16a2 2 0 001.414-.586l4-4a2 2 0 000-2.828l-4.758-4.758a2 2 0 00-2.828 0l-4 4A2 2 0 009 9.243v4.344L11.413 16z"
        fill={color}
      />
    </SvgIcon>
  )
}
